<template>
  <div>
    <quill-editor v-model="text"
                  ref="editor"
                  :options="editorOption"
                  class="editor"
                  @change="editorChange" />
    <el-upload v-show="false"
               id="upload-image"
               action="#"
               :http-request="onUploadImage"
               accept="image/*"></el-upload>
    <el-upload v-show="false"
               id="upload-video"
               action="#"
               :http-request="onUploadVideo"
               accept=".mp4,.mov,.3gp,.wmv,.rm,.rmvb,.m4v,.avi,.mkv,.flv"></el-upload>
  </div>
</template>

<script>
import { quillEditor, Quill } from "vue-quill-editor";
import "video.js/dist/video-js.min.css"
import Videojs from "video.js"
const Image = Quill.import("formats/image");
const Link = Quill.import("formats/link");
Image.sanitize = (url) => {
  return Link.sanitize(url, ["http", "https", "data", "blob"]) ? url : "//:0";
};
import Video from "./video.js"; // 插入h5 video视频
Quill.register(Video, true); // 注册video
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// import func from 'vue-temp/vue-editor-bridge.js';
const titleConfig = [
  { Choice: '.ql-header[value="1"]', title: "一级标题" },
  { Choice: '.ql-header[value="2"]', title: "二级标题" },
  { Choice: ".ql-image", title: "图像" },
  { Choice: ".ql-video", title: "视频" }
];
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      text: "",
      origin: "",
      editorOption: {
        modules: {
          toolbar: {
            container: [
              [
                {
                  header: 1
                },
                {
                  header: 2
                }
              ],
              [
                {
                  header: [1, 2, 3, 4, 5, 6, false]
                }
              ],

              ["image", "video"]
            ], // 工具栏
            handlers: {
              image (value) {
                if (value) {
                  document
                    .querySelector("#upload-image .el-upload__input")
                    .click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video (value) {
                if (value) {
                  document
                    .querySelector("#upload-video .el-upload__input")
                    .click();
                } else {
                  this.quill.format("video", false);
                }
              }
            }
          }
        }
      },
      imgList: [
        // {
        //   type: "image/video", // 文件类型
        //   localUrl: "", // 本地存储路径
        //   fileData: {} // 文件流
        // }
      ],
      videoList: []
    };
  },
  components: {
    quillEditor
  },
  methods: {
    onUploadImage (file) {
      //   const imgUrl = "http://yapi.yading.xyz/api/user/avatar?uid=203";
      const localUrl = this.getLocalFileUrl(file.file);
      this.imgList.push({
        type: "image",
        localUrl: localUrl,
        fileData: file.file
      });
      this.inSertContent("image", localUrl);
    },
    onUploadVideo (file) {
      // console.log(file);
      const localUrl = this.getLocalFileUrl(file.file);
      // const a = Math.random()
      this.videoList.push({
        type: "video",
        localUrl: localUrl,
        fileData: file.file
      });
      //   const videoUrl =
      //     "http://118.123.199.216/youku/65728420cb03f71a391d64a95/03000801005F0ECD912BB03003E8800EF6766D-A478-4D44-9F17-B2AB556DC476.mp4?sid=159659526600010009542_00_B5760b54402b42e3ab2f7191731bc5782&sign=b3541c0d5bb5839201d4e3069ea3c4bc&ctype=50&si=183&psid=5e14c2dec2f99757ed052f0a3abea9a146e4e&ali_redirect_domain=vali-g1.cp31.ott.cibntv.net&ali_redirect_ex_hot=23937999&ali_redirect_ex_beacon=1";
      this.inSertContent("video", localUrl);
    },
    inSertContent (type, url, a) {
      const quill = this.$refs.editor.quill;
      const addLocation = quill.getSelection();
      quill.insertEmbed(addLocation.index, type, url);
      quill.setSelection(addLocation.index + 1);
    },
    getLocalFileUrl (file) {
      return window.URL.createObjectURL(file);
    },
    submit () {
      if (this.list.length === 0) {
        return;
      } else {
        // const list = [];
        // //
        // this.fileSaveList.forEach((file) => {
        //   list.push(() => {
        //     const formData = new FormData();
        //     formData.append("file", file.fileData);
        //     return this.$axios
        //       .put(`/url`, formData, {
        //         headers: {
        //           "Content-Type": "multipart/form-data"
        //         }
        //       })
        //       .then((res) => {
        //         const reg = new RegExp(file.localUrl, "g");
        //         this.text = this.text.replace(reg, res);
        //       });
        //   });
        // });
        // //
        // new Promise.all(list).then((res) => {
        //   console.log(this.text, res);
        // });
      }
    },
    syncFile (allTypeFile, type, dataType) {
      const imgOrVideo = allTypeFile.filter(ele => ele.indexOf(window.StaticUrl) === -1)
      const imageOrVideo = this[dataType].filter(ele => ele.type === type)
      if (imageOrVideo.length > imgOrVideo.length) {
        const diff = imageOrVideo.filter(ele => {
          return imgOrVideo.some(elem => elem.indexOf(ele.localUrl) === -1)
        })
        this[dataType] = this[dataType].filter(ele => diff.every(elem => elem.localUrl !== ele.localUrl));
      }
    },
    editorChange (e) {
      // 删除
      // if (this.text.length > e.html.length) {
      //   this.origin = this.text
      // } else {
      //   this.origin = ''
      // }
      this.$emit("input", e.html);
      this.$nextTick(() => {
        console.log(this.origin.length, this.text.length)
        if (this.origin.length > this.text.length) {
          const imgReg = /<img.*?(?:>|\/>)/gi;
          const allImg = this.text.match(imgReg)
          console.log(allImg)
          if (!allImg) {
            this.imgList = []
          } else {
            // debugger;
            const img = allImg.filter(ele => ele.indexOf(window.StaticUrl) === -1)
            const image = this.imgList.filter(ele => ele.type === 'image')
            if (image.length > img.length) {
              const diff = image.filter(ele => {
                return img.every(elem => elem.indexOf(ele.localUrl) === -1)
              })
              const res = this.imgList.filter(ele => diff.every(elem => elem.localUrl !== ele.localUrl));
              console.log(res)
              this.$set(this, 'imgList', res)
            }
          }
          const videoReg = /<video.*?(?:>|\/>)/gi;
          const allVideo = this.text.match(videoReg)
          if (!allVideo) {
            this.videoList = []
          } else {
            console.log(allVideo)
            const video = allVideo.filter(ele => ele.indexOf(window.StaticUrl) === -1)
            if (this.videoList.length > video.length) {
              const diff = this.videoList.filter(ele => {
                return video.every(elem => elem.indexOf(ele.localUrl) === -1)
              })
              const res = this.videoList.filter(ele => diff.every(elem => elem.localUrl !== ele.localUrl));
              this.$set(this, 'videoList', res)
            }
          }
        }
      })
    }
  },
  watch: {
    text (val, old) {
      if (val.length >= old.length) {
        this.origin = ''
      } else {
        this.origin = old;
      }
    }
  },
  mounted () {
    // this.text = this.value || ""
    document.getElementsByClassName("ql-editor")[0].dataset.placeholder = "";
    for (const item of titleConfig) {
      const tip = document.querySelector(".quill-editor " + item.Choice);
      if (!tip) continue;
      tip.setAttribute("title", item.title);
    }
  }
};
</script>

<style lang="scss" scoped>
.editor {
  display: flex;
  flex-direction: column;
  & /deep/ .ql-container {
    > .ql-editor {
      min-height: 400px;
      background-color: white;
      // color: red;
      // }
    }
  }
  & /deep/ .ql-toolbar .ql-picker .ql-picker-label {
    outline: none;
    &::before {
      transform: translateY(-8px);
    }
  }
}
</style>
